import { X } from "lucide-react";
import { useEffect } from "react";

const BOOKING_URL = "https://api.leadconnectorhq.com/widget/bookings/ampa-demo-call";

interface BookingModalProps {
  open: boolean;
  onClose: () => void;
}

export default function BookingModal({ open, onClose }: BookingModalProps) {
  // Lock body scroll when open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative z-10 w-[95vw] h-[95vh] md:w-[90vw] md:h-[90vh] rounded-xl border bg-card shadow-2xl overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h3 className="font-semibold">Schedule a Demo</h3>
          <button
            onClick={onClose}
            className="p-1 rounded-md hover:bg-muted transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Iframe */}
        <iframe
          src={BOOKING_URL}
          className="flex-1 w-full border-0"
          title="Schedule a Demo"
          allow="camera; microphone"
        />
      </div>
    </div>
  );
}

// Hook for easy use across components
import { useState, useCallback } from "react";

export function useBookingModal() {
  const [open, setOpen] = useState(false);
  const openBooking = useCallback(() => setOpen(true), []);
  const closeBooking = useCallback(() => setOpen(false), []);
  return { open, openBooking, closeBooking };
}
